import script from "./ClientRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientRegister.vue?vue&type=script&setup=true&lang=js"

import "./ClientRegister.vue?vue&type=style&index=0&id=0a086a77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a086a77"]])

export default __exports__